import { gql } from 'apollo-angular';

const searchShipmentFragment = gql`
  fragment SearchShipment on Shipment {
    id
    status
    originPlace
    destinationPlace
    quoteNumber
  }
`;

const searchLtlQuoteRequestFragment = gql`
  fragment SearchLtlQuoteRequest on LtlQuoteRequest {
    id
    status
    quoteNumber
    bolNumber
    proNumber
  }
`;

/**
 * Global (top-navigation) search. Lighthouse-api has no single search
 * resolver, so this hits the shipments and ltlQuoteRequests list resolvers in
 * parallel, each gated by an `@include` flag driven by the user's permissions.
 */
export const globalSearchQuery = gql`
  query GlobalSearch(
    $page: Int
    $size: Int!
    $whereShipments: QueryShipmentsWhereWhereConditions
    $whereQuotes: QueryLtlQuoteRequestsWhereWhereConditions
    $canQueryShipment: Boolean! = true
    $canQueryQuote: Boolean! = true
  ) {
    shipments(page: $page, first: $size, where: $whereShipments)
      @include(if: $canQueryShipment) {
      data {
        ...SearchShipment
      }
    }
    ltlQuoteRequests(page: $page, first: $size, where: $whereQuotes)
      @include(if: $canQueryQuote) {
      data {
        ...SearchLtlQuoteRequest
      }
    }
  }
  ${searchShipmentFragment}
  ${searchLtlQuoteRequestFragment}
`;
